import { OrderbookItem } from '@/types/otc'

export interface CategoryItem extends OrderbookItem {
  change?: number
  category?: string
}

export interface CategoriesBaseProps {
  items: CategoryItem[]
  categories?: string[]
  selectedCategory?: string
  onCategoryChange?: (category: string) => void
  onItemClick?: (item: CategoryItem) => void
  loading?: boolean
}

export const defaultCategories = ['DeFi', 'AI', 'Infra', 'Pre-IPO', 'SAFT', '🔥 Sale']

// Colors from Figma design: #6cb211, #1197b2, #b29d11, #e461ce
export const categoryColors = [
  '#6cb211', // green
  '#1197b2', // teal
  '#b29d11', // yellow/gold
  '#e461ce', // pink/magenta
  '#6cb211', // green (repeat pattern)
  '#1197b2', // teal (repeat pattern)
]

export const formatChange = (change: number): string => {
  // Format change value exactly as in Figma: -15%, -10%, +5%, -20%
  return change >= 0 ? `+${change}%` : `${change}%`
}

